"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KG = void 0;
exports.KG = {
    numericCode: '417',
    alpha2Code: 'KG',
    alpha3Code: 'KGZ',
    englishName: {
        short: 'Kyrgyzstan',
        full: 'the Kyrgyz Republic',
    },
    names: {
        full: {
            en: 'the Kyrgyz Republic',
            fr: 'la République kirghize',
            ky: 'Kyrgyzstan',
            ru: 'Kyrgyzstan',
        },
        short: {
            en: 'Kyrgyzstan',
            fr: 'Kirghizistan (le)',
            ky: 'Kyrgyzstan',
            ru: 'Kyrgyzstan',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ky',
            languageAlpha3Code: 'kir',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'ru',
            languageAlpha3Code: 'rus',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'KG-GB': {
            numericCode: '417',
            code: 'KG-GB',
            category: {
                id: '187',
                names: {
                    en: {
                        singular: 'city',
                        plural: 'cities',
                    },
                    fr: {
                        singular: 'ville',
                        plural: 'villes',
                    },
                    ky: {
                        singular: 'shaar',
                        plural: '',
                    },
                    ru: {
                        singular: 'gorod',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Bishkek Shaary',
                ru: 'Gorod Bishkek',
            },
        },
        'KG-GO': {
            numericCode: '417',
            code: 'KG-GO',
            category: {
                id: '187',
                names: {
                    en: {
                        singular: 'city',
                        plural: 'cities',
                    },
                    fr: {
                        singular: 'ville',
                        plural: 'villes',
                    },
                    ky: {
                        singular: 'shaar',
                        plural: '',
                    },
                    ru: {
                        singular: 'gorod',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Osh Shaary',
                ru: 'Gorod Oš',
            },
        },
        'KG-B': {
            numericCode: '417',
            code: 'KG-B',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Batken',
                ru: "Batkenskaja oblast'",
            },
        },
        'KG-C': {
            numericCode: '417',
            code: 'KG-C',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Chüy',
                ru: "Chuyskaya oblast'",
            },
        },
        'KG-J': {
            numericCode: '417',
            code: 'KG-J',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Jalal-Abad',
                ru: "Dzhalal-Abadskaya oblast'",
            },
        },
        'KG-N': {
            numericCode: '417',
            code: 'KG-N',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Naryn',
                ru: "Narynskaya oblast'",
            },
        },
        'KG-O': {
            numericCode: '417',
            code: 'KG-O',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Osh',
                ru: "Oshskaya oblast'",
            },
        },
        'KG-T': {
            numericCode: '417',
            code: 'KG-T',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Talas',
                ru: "Talasskaya oblast'",
            },
        },
        'KG-Y': {
            numericCode: '417',
            code: 'KG-Y',
            category: {
                id: '328',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    ky: {
                        singular: 'oblus',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ky: 'Ysyk-Köl',
                ru: "Issyk-Kul'skaja oblast'",
            },
        },
    },
    cities: [
        {
            name: 'Suluktu',
            subdivision: 'Batken',
        },
        {
            name: 'Isfana',
            subdivision: 'Batken',
        },
        {
            name: 'Balykchy',
            subdivision: 'Ysyk-Köl',
        },
        {
            name: 'Tokmok',
            subdivision: 'Chüy',
        },
        {
            name: 'Tash-Kumyr',
            subdivision: 'Jalal-Abad',
        },
        {
            name: 'Talas',
            subdivision: 'Talas',
        },
        {
            name: 'Kyzyl-Suu',
            subdivision: 'Ysyk-Köl',
        },
        {
            name: 'Uzgen',
            subdivision: 'Osh',
        },
        {
            name: 'Osh',
            subdivision: 'Osh',
        },
        {
            name: 'Naryn',
            subdivision: 'Naryn',
        },
        {
            name: 'Kyzyl-Kyya',
            subdivision: 'Batken',
        },
        {
            name: 'Kara Suu',
            subdivision: 'Osh',
        },
        {
            name: 'Karakol',
            subdivision: 'Ysyk-Köl',
        },
        {
            name: 'Kara-Balta',
            subdivision: 'Chüy',
        },
        {
            name: 'Kant',
            subdivision: 'Chüy',
        },
        {
            name: 'Jalal-Abad',
            subdivision: 'Jalal-Abad',
        },
        {
            name: 'Iradan',
            subdivision: 'Batken',
        },
        {
            name: 'Cholpon-Ata',
            subdivision: 'Ysyk-Köl',
        },
        {
            name: 'Bishkek',
            subdivision: 'Bishkek',
        },
        {
            name: 'Bazar-Korgon',
            subdivision: 'Jalal-Abad',
        },
        {
            name: 'At-Bashi',
            subdivision: 'Naryn',
        },
        {
            name: 'Toktogul',
            subdivision: 'Jalal-Abad',
        },
        {
            name: 'Osh City',
            subdivision: 'Osh City',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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